// Callback shortcuts (spec 04 §3): tomorrow, next Monday, +7 days, at the default callback time, in the lead's zone.
// GAVION missed-call: a shortcut never lands on a Saturday, a Sunday, Dec 25 or Jan 1 (« Demain » on a Friday is
// Monday); same time.
import { zonedTimeToUtc } from "../../domain/torontoTime";
import { addDays, nextCallbackDay, zoneParts } from "../../domain/time";

export type QuickChip = {
  key: "tomorrow" | "monday" | "next_week";
  /** Value for a datetime-local input (lead time zone). */
  local: string;
  iso: string;
};

const pad = (n: number) => String(n).padStart(2, "0");

export function quickChips(now: Date, tz: string, at: string): QuickChip[] {
  const p = zoneParts(now, tz);
  const today = `${p.year}-${pad(p.month)}-${pad(p.day)}`;
  const days: Record<QuickChip["key"], number> = {
    tomorrow: 1,
    monday: p.weekday === 1 ? 7 : 8 - p.weekday,
    next_week: 7,
  };
  return (Object.keys(days) as QuickChip["key"][]).map((key) => {
    const day = nextCallbackDay(addDays(today, days[key]));
    return {
      key,
      local: `${day}T${at}`,
      iso: zonedTimeToUtc(day, at, tz).toISOString(),
    };
  });
}
